// HintPopup.jsx
// Per-field hint alert for the Book activity — matches room.php's SweetAlert2
// `.my-popup` (small_modal.png background, "OK" confirm button, brown fill),
// not the X-close modal used by Story/Learning popups.
import React from 'react';
import GamePopup from './GamePopup';
import './HintPopup.css';

function HintPopup({ open, onClose, text, testId = 'escape-hint-popup' }) {
  return (
    <GamePopup open={open} onClose={onClose} size="small" ariaLabel="Hint" closeButton={false} testId={testId}>
      <div className="escape-hint-text">{text}</div>
      <button type="button" className="escape-hint-ok-btn" onClick={onClose} data-testid="escape-hint-ok">
        OK
      </button>
    </GamePopup>
  );
}

export default HintPopup;
